/**
 * Class util for Map
 */
export default class MapUtil {

    /**
     * Transform an object to a map
     * @param obj the object
     * @return {Map} the map with all properties object as key
     */
    static objectToMap(obj) {
        const tmp = new Map();
        for (let property in obj) {
            if (obj.hasOwnProperty(property)) {
                tmp.set(property, obj[property]);
            }
        }
        return tmp;
    }

    /**
     * Delete a list of keys from a map
     * @param {Map} map the input map
     * @param {Array} keys the keys to delete
     * @return {Map} the map with keys deleted (be careful, the input map is also changed)
     */
    static excludeKeys(map, keys) {
        keys.forEach((value) => {
            map.delete(value);
        });
        return map;
    }

}


// WEBPACK FOOTER //
// ./js/core/utils/MapUtil.js